import { Box } from '@mui/material'
import { Outlet } from 'react-router'
import HeaderWorkspace from '../components/HeaderWorkspace'
import SidebarWorkspace from '../components/SidebarWorkspace'

export default function WorkspaceLayout() {
  const headerHeight = '4.5rem'
  const sidebarWidth = '20rem'

  return (
    <Box>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: headerHeight,
          zIndex: 1300
        }}
      >
        <HeaderWorkspace />
      </Box>

      <Box
        sx={{
          position: 'fixed',
          width: sidebarWidth,
          height: `calc(100vh - ${headerHeight})`,
          zIndex: 1200,
          overflowY: 'auto'
        }}
      >
        <SidebarWorkspace />
      </Box>

      <Box
        sx={{
          marginLeft: sidebarWidth,
          marginTop: headerHeight,
          height: `calc(100vh - ${headerHeight})`,
          overflowY: 'auto'
        }}
      >
        <Outlet />
      </Box>
    </Box>
  )
}
